import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=2788e1e7&scoped=true&"
import script from "./ProfileView.vue?vue&type=script&lang=js&"
export * from "./ProfileView.vue?vue&type=script&lang=js&"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=2788e1e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788e1e7",
  null
  
)

export default component.exports